import React from 'react';

export function Lifting() {
  return (
    <div className="space-y-4">
      <div className="bg-primary rounded-lg p-4 text-center h-[50px] flex items-center justify-center">
        <h1 className="text-xl text-white">LIFTING FACIAL JAPONÉS</h1>
      </div>
      <div className="grid grid-cols-1 gap-4">
        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <h2 className="text-lg font-semibold text-primary">Lifting facial japonés</h2>
            <p className="text-gray-600">
              El lifting facial japonés es un masaje con siglos de antigüedad, que utilizaban las emperatrices japonesas para mantener su piel joven.
              <br /><br />
              Es un tratamiento con maniobras de masaje únicas que buscan el equilibrio entre la salud física, emocional y espiritual. Se le conoce como el 'lifting sin cirugía'.
              <br /><br />
              Es un tratamiento personalizado.
              <br />
              Incluye producto 100% natural.
              <br />
              No incluye extracción ni depilación de cejas y/o labio.
              <br /><br />
              <strong>Duración:</strong> 60 min
              <br />
              <strong>Precio:</strong> 65€
            </p>
            <a 
              href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
              className="block mt-4 bg-primary text-white text-center px-4 py-2 rounded-full hover:bg-primary/90 transition-colors font-medium"
            >
              CITA PREVIA
            </a>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <h2 className="text-lg font-semibold text-primary">Bono 4 + 1</h2>
            <p className="text-gray-600">
              Para resultados más duraderos, se recomienda un tratamiento continuado.
              <br /><br />
              <strong>Duración:</strong> 60 min por sesión
              <br />
              <strong>Precio:</strong> 260€
              <br />
              <strong>Caducidad:</strong> 3 meses
            </p>
            <a 
              href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
              className="block mt-4 bg-primary text-white text-center px-4 py-2 rounded-full hover:bg-primary/90 transition-colors font-medium"
            >
              CITA PREVIA
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}